import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-network-error',
  templateUrl: './network-error.component.html',
  styleUrls: ['./network-error.component.scss'],
})
export class NetworkErrorComponent implements OnInit {
  constructor(private spinner: NgxSpinnerService) {}

  /**
   * On page initialization
   */
  ngOnInit(): void {
    this.spinner.hide();
  }
}
